export function pushDL(event, payload) {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event,
    ...payload,
  });

  if (process.env.NODE_ENV === 'development') {
    console.log(
      '%cDATALAYER →',
      'color:#4CAF50;font-weight:bold',
      event,
      payload,
    );
  }
}

export function trackFormStart(payload) {
  pushDL('contract_form_start', payload);
}

export function trackFormProgress(payload) {
  pushDL('contract_form_progress', payload);
}

export function trackFormComplete(payload) {
  pushDL('contract_form_complete', payload);
}

export function trackContractSignature(payload) {
  pushDL('contract_signature', payload);
}

export function trackPageView(payload) {
  pushDL('page_view', payload);
}
